var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"CatalogFiltersWidgetSlider"},[_c('RangeSlider',{attrs:{"interval":0.1,"value":[
      (_vm.parameter.selectedRange && _vm.parameter.selectedRange[0]) || _vm.parameter.range[0],
      (_vm.parameter.selectedRange && _vm.parameter.selectedRange[1]) || _vm.parameter.range[1]
    ],"min":_vm.parameter.range[0],"max":_vm.parameter.range[1],"unit":_vm.parameter.cms.parameter_unit},on:{"change":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }